import { Outlet } from "react-router-dom";
import Layout from "../components/Layout";

export default function ProfileLayout() {
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  // worker → داخل Layout
  if (user?.role === "user") {
    return (
      <Layout>
        <Outlet />
      </Layout>
    );
  }

  // client → بدون Layout
  return <Outlet />;
}
